import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from "reactstrap";
import Service from "src/api/Service"
import dashboard from 'src/assets/dashboard.svg'
import calander from 'src/assets/icons/calender.svg'
function MiniKpi(props){

  const [form, setForm] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [countFilter, setCountFilter] = useState(false);

  const [Data, setData] = useState([]);
  return(
    <>
         <div className='componentICON' ><div className='row'> <div className='col-sm-3' style={{marginLeft:'8px'}}>
           <img className='card' style={{backgroundColor:'#26A0FC' ,padding:'10px',marginTop:'-30px'}} src={dashboard} />
           </div> <div className='col-sm-8' style={{marginLeft:'-16px'}}>  <span className='componentNameC' style={{background:'#26A0FC'}} >{props.prams.prams.component} </span></div></div></div>
    
        <div className='p-2' style={{padding:'0.0rem !important'}}>
        <Row key={props.prams.keyname}>
            
         
          <div className="col-sm topcard" style={{textAlign: 'left'}}>
          <p className="cardClass"><span className='font20' style={{fontSize:'23px',color:'#26A0FC' ,fontWeight: '500',marginLeft:'8px'}}>{props.prams.filterData[props.prams.prams.kpiId]['first_value']}</span></p>
          <h5 style={{fontSize:'15px', marginTop:'-10px',color:'#26A0FC',fontWeight: '500', marginLeft:'8px'}}>{props.prams.filterData[props.prams.prams.kpiId]['first_label']} &nbsp;  </h5>
        
          </div>                  

          <div  className="col-sm topcard" style={{textAlign: 'Right'}}>
          <p className="cardClass"><span className='font20' style={{fontSize:'23px',color:'#26A0FC',fontWeight: '500',marginRight:'8px'}}>{props.prams.filterData[props.prams.prams.kpiId]['second_value']}</span></p>
          <h5 style={{fontSize:'15px', marginTop:'-10px',color:'#26A0FC',fontWeight: '500'}}>{props.prams.filterData[props.prams.prams.kpiId]['second_label']} &nbsp;  </h5>
       
            
          </div>       
          <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 1, backgroundColor: '#d2d2d6',color:'#26A0FC', height: ".5px", marginTop:"0px" }} />
          </div>
          <p style={{fontSize:'15px',fontWeight: '500',color:'#FEB019', marginTop:'5px', marginLeft:'8px'}}><img src={calander}></img>&nbsp; {props.prams.filterData[props.prams.prams.kpiId]['period']} &nbsp;  </p>
          </Row>

        </div>
          
     
    </>
  )
}
export default MiniKpi



